module.exports = __webpack_public_path__ + "img/665.af688d35.png";